import { Component, OnInit, Input, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';

import { Password } from '../../core/index.model'
import { SessionStorageService, PageContentService, PasswordService } from '../../core/index.service'
import { UserRole } from '../../core/enumtype';
import { Guid } from '../../core/guid';
import { EmailControl } from '../../shared/controls/email.control';

@Component({
    selector: 'shared-passwordrecovery',
    templateUrl: './passwordrecovery.component.html'
})
export class PasswordRecoveryComponent implements OnInit {

    @Input() isAdmin: boolean = false;
    @Input() isSetFocus: boolean = false;

    @ViewChild(EmailControl) emailControl: EmailControl;

    public pwdForm: FormGroup;

    message: string;
    isError: boolean = false;
    isAlert: boolean = false;
    isWarning: boolean;
    showLoading: boolean = false;

    constructor(
        private fb: FormBuilder,
        private passwordService: PasswordService,
        private storageService: SessionStorageService,
        private pagecontentService: PageContentService
    ) { }

    ngOnInit() {
        this.formGroup();
    }
    
    // From Control Group

    formGroup() {
        this.pwdForm = this.fb.group({
            TempPwdID: null,
            JurisID: null,
            UserID: null,
            UserRole: null,
            Email: null,
            IPAddress: null,
            IsActive: 1,
        });
    }

    // Submit

    cmdSubmit(model: Password, isValid: boolean) {

        model.TempPwdID = Guid.newGuid();
        model.UserID = Guid.emptyGuid();

        if (this.isAdmin) {
            model.UserRole = UserRole.Admin.toString();
            model.IsAdmin = 1;
        }
        else {
            model.UserRole = UserRole.Citizen.toString();
            model.IsAdmin = 0;
        }

        model.JurisID = this.storageService.getJurisNo();

        if (isValid) {

            this.showLoading = true;

            this.passwordService.forgetPassword(model).then(res => {
                if (res.UserID !== Guid.emptyGuid()) {
                    this.showAlert(this.pagecontentService.getKeyTxt('Msg_Recovery_Pwd', this.storageService.getLang()), false);
                }
                else {
                    this.showAlert(this.pagecontentService.getKeyTxt('Msg_EmailNotExist', this.storageService.getLang()), true, true);
                }
                this.showLoading = false;
            }).catch(err => {
                this.showAlert(err, true);
                this.showLoading = false;
            });
        }
        else {
            if(this.emailControl.value && !this.emailControl.isValidEmail)
                this.showAlert(this.pagecontentService.getKeyTxt('Msg_InvalidEmail', this.storageService.getLang()), true, true);
            else
                this.showAlert(this.pagecontentService.getKeyTxt('Msg_Mandatory', this.storageService.getLang()), true, true);
        }
    }

    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/passwordrecovery.component.ts